import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import ModalButtons from "../ModalButtons/ModalButtons";
import CreditCardForm from "../BookingFlow/CreditCardForm";
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ElementsConsumer, CardElement } from '@stripe/react-stripe-js';

export default class CardBuilder extends React.Component {

  constructor(props){
    super(props);
    this.state={
      lodading: false,
      card: this.props.card ? this.props.card : {save_card: true, customer_id: this.props.customer_id},
      stripe: null,
    };
    this.onChangeCardInput = this.onChangeCardInput.bind(this);
    this.save = this.save.bind(this);
  };

  async componentDidMount() {
    const stripe = await loadStripe(this.props.public_gateway_key, {
      locale: navigator.languages && navigator.languages.length
        ? navigator.languages[0]
        : navigator.language
    });

    this.setState({ stripe: stripe });
  };

  render(){
    return(
      <div className="CardBuilder">
        {this.renderHeaderErrors()}
        {
          this.state.stripe
          ?
            <Elements
              stripe={this.state.stripe}
            >
              <ElementsConsumer>
                {({ stripe, elements }) => (
                  [
                    <CreditCardForm
                      key="cc-form"
                      card={this.state.card}
                      onChangeCardInput={this.onChangeCardInput}
                      // stacked={true}
                      errors={this.state.errors}
                    />,
                    <ModalButtons loading={this.state.loading} buttons={this.buttons(elements)} key="buttons" />
                  ]
                )}
              </ElementsConsumer>
            </Elements>
          :
          null
        }

        <LoadingSpinner show={this.state.loading} />

      </div>
    );
  };

  buttons(elements){
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ],
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary', 'modal-footer', 'btn-primary', 'submit-buttons'],
        onClick: (e) => {
          this.save(e, elements);
        }
      },
    ];
    return buttons
  };

  renderHeaderErrors() {
    if (this.state.errors) {
      var previousNameError = false
      var errors = this.state.errors.map((error, idx) => {
        if (error.toLowerCase().includes('name')) {
          if (!previousNameError) {
            previousNameError = true
            return <li key={idx}>{I18n.t('name_on_card_error')}</li>;
          };
        } else if (error.toLowerCase().includes('number') || error.toLowerCase().includes('month') || error.toLowerCase().includes('year') || error.toLowerCase().includes('amount')) {
          return <li key={idx}>{error}</li>;
        } else if (error.toLowerCase().includes('verification value')) {
          return <li key={idx}>{I18n.t('security_code_error')}</li>
        } else return <li key={idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    };
  };

  onChangeCardInput(e){
    var updatedCard = Object.assign({}, this.state.card);
    updatedCard[e.target.name] = e.target.value;
    this.setState({
      card: updatedCard,
    });
  };

  async save(e, elements){
    e.preventDefault();

    if(this.state.card.name_on_card) {

      var stripe = this.state.stripe;
      var cardElement = elements.getElement(CardElement);

      if (!stripe || !elements) {
        return;
      }

      const result = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
        billing_details: {
          name: this.state.card.name_on_card,
        },
      });

      if (result.error) {
        this.setState({
          errors: [result.error.message]
        })
      } else {

        this.setState({ loading: true });

        $.ajax({
          type: 'POST',
          url: '/admin/cards/save',
          data: {
            payment_token: result.paymentMethod,
            customer_id: this.props.customer_id
          },
        }).done((data) => {
          if (data.success) {
            this.setState({ loading: false })
            window.parent.$(window.parent).trigger("folioItemSavedSuccessfully")
            parent.refresh_data()
            parent.hide_modal()
          } else if (data.errors) {
            this.setState({
              loading: false,
              errors: data.errors,
            });
          };
        });
      };

    } else {
      this.setState({
        errors: [I18n.t('card_name_cant_be_blank')]
      });
    };




  };
};
